export default __webpack_public_path__ + "11c41ba1bb64ca4ce58566be91fb049a.png";